/**
 * 手動イベントの最小セット定義（GF-1888 / GF-1896）。
 *
 * ⚠️ Autocapture 主軸の運用方針：
 *   - クリック / ページ遷移 / フォーム submit は Autocapture に任せ、ここに追加しない。
 *   - ここに定義するのは「Autocapture で取れない / 信頼性が必要なドメインイベント」だけ。
 *   - 新規追加は docs（posthog.md）の承認フローに従うこと。「念のため」の追加は禁止。
 *
 * イベント名・プロパティキーは分析側の慣習に合わせ snake_case で定義する。
 */
export const EVENT_NAMES = {
  /** 購入完了。金額・商品ID・注文ID は Autocapture では取れないため手動送信する。 */
  purchaseCompleted: 'purchase_completed',
  /** 新規会員登録完了。登録の確定は API 成功でしか判定できないため手動送信する（購入と並ぶ CV イベント）。 */
  signupCompleted: 'signup_completed',
} as const;

export type EventName = (typeof EVENT_NAMES)[keyof typeof EVENT_NAMES];

/**
 * 各手動イベントのプロパティスキーマ。キーは {@link EVENT_NAMES} の「値」。
 * PII（メール / 住所 / 電話 / カード番号）は絶対に含めない。
 */
export type EventProperties = {
  purchase_completed: {
    order_id: string;
    /** 税込合計金額 */
    amount: number;
    product_ids: string[];
    /** 購入商品の合計点数 */
    quantity: number;
    /** 'credit' | 'paypay' 等の決済手段 */
    payment_method: string;
    /** 会員購入かゲスト購入か */
    is_guest: boolean;
  };
  /** 登録情報（メール・氏名等）は PII のためプロパティは送らない */
  signup_completed: Record<string, never>;
};
